<div class="login-page">
  <div class="container d-flex align-items-center">
    <div class="form-holder has-shadow">
      <div class="row">
        <!-- Logo & Information Panel-->
        <div class="col-lg-6">
          <div class="info d-flex align-items-center blue-bg">
            <div class="content">
              <div class="logo">
                <h1>Create Free Account</h1>
              </div>
            </div>
          </div>
        </div>
        <!-- Form Panel    -->
        <div class="col-lg-6 bg-white">
          <div class="form d-flex align-items-center">
            <div class="content">
              <form (ngSubmit)="register()" [formGroup]="registerForm" class="form-validate" novalidate>
                <ng-container *ngIf="errors$ | async as errors">
                  <ul class="error-list">
                    <li *ngFor="let item of errorItems">{{ item }}</li>
                  </ul>
                </ng-container>
                <!-- <div class="form-group">
                  <input
                    type="text"
                    formControlName="user_name"
                    autocomplete="off"
                    class="input-material"
                    placeholder="Username"
                    [disableControl]="!(loading$ | async)"
                    maxlength="255"
                  />
                  <div *ngIf="f.user_name.invalid && (f.user_name.dirty || f.user_name.touched)">
                    <div *ngIf="f.user_name.errors" class="required-text">
                      <div *ngIf="f.user_name.errors.required">User Name is required.</div>
                      <div *ngIf="f.user_name.errors.minlength">Must be minimum of 8 alphanumeric characters.</div>
                      <div *ngIf="f.user_name.errors.maxlength">Must be max of 255 alphanumeric characters.</div>
                    </div>
                  </div>
                </div> -->
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="email"
                    autocomplete="off"
                    class="input-material"
                    placeholder="Email"
                    [disableControl]="!(loading$ | async)"
                  />
                  <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)">
                    <div *ngIf="f.email.errors" class="required-text">
                      <div *ngIf="f.email.errors.required">Please enter an email address.</div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    formControlName="password"
                    required
                    class="input-material"
                    placeholder="Password"
                    [disableControl]="!(loading$ | async)"
                  />
                  <div *ngIf="f.password.invalid && (f.password.dirty || f.password.touched)">
                    <div *ngIf="f.password.errors" class="required-text">
                      <div *ngIf="f.password.errors.required">Please enter your desired password</div>
                    </div>
                  </div>
                </div>
                <div class="form-group terms-conditions">
                  <input
                    id="register-agree"
                    name="registerAgree"
                    formControlName="agree"
                    type="checkbox"
                    required
                    value="0"
                    class="checkbox-template"
                    [disableControl]="!(loading$ | async)"
                  />
                  <label for="register-agree">I am at least 18 years old and over</label>
                </div>
                <!-- <div *ngIf="f.agree.invalid && (f.agree.dirty || f.agree.touched)">
                  <div *ngIf="f.agree.errors" class="required-text">
                    <div *ngIf="f.agree.errors.required">You should agree to create an account</div>
                  </div>
                </div> -->
                <button
                  class="btn btn-primary"
                  type="submit"
                  [disabled]="registerForm.invalid || (loading$ | async)"
                  id="login"
                >
                  <ng-container *ngIf="!(loading$ | async)">
                    <span translate>Submit</span>
                  </ng-container>
                  <ng-container *ngIf="loading$ | async">
                    <span translate>Loading..</span>
                  </ng-container>
                </button>
                <!-- This should be submit button but I replaced it with <a> for demo purposes-->
              </form>
              <small>Already have an account? </small><a class="signup white" [routerLink]="['/login']">Sign In</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
